import React from 'react'
import { useState, useEffect } from 'react'
import { Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'
import secureLocalStorage from 'react-secure-storage'
import CardQuickGuide from './CardQuickGuide'
import CardHomeTeacherLink from '../components/CardHomeTeacherLink'
import CardHomeAnalyticsStudent from '../components/CardHomeAnalyticsStudent'
import CardStudentLink from './CardStudentLink'

import LeaderboardOutlinedIcon from '@mui/icons-material/LeaderboardOutlined'
import TodayOutlinedIcon from '@mui/icons-material/TodayOutlined'
import TextsmsOutlinedIcon from '@mui/icons-material/TextsmsOutlined'
import FindInPageOutlinedIcon from '@mui/icons-material/FindInPageOutlined'

import AttachmentService from '../../services/AttachmentService'

export default function HomeAreaStudent() {
  const { t } = useTranslation()

  const localPermissions = secureLocalStorage.getItem('permissions')?.toString()
  const permissions = localPermissions?.split(',')

  const [url, setUrl] = useState('')

  const feature = 'quickguide'
  const idGuide = 2 //id do perfil coordenador, porque o manual é o mesmo p/ aluno
  const name = 'manual_hiplade_coordinator' // nome de campo do perfil coodenador

  const getFile = async () => {
    await AttachmentService.get(feature, idGuide, name)
      .then((response) => {
        if (response.data.length > 0) {
          setUrl(response.data[0].url)
        }
      })
      .catch(() => {})
  }

  useEffect(() => {
    if (idGuide) {
      getFile()
    }
  }, [])

  const openQuickGuide = url
    ? () => window.open(url, '_blank', 'noopener,noreferrer')
    : undefined

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <CardQuickGuide
          title={t('btn_quick_guide')}
          subtitle={t('subtitle_quick_guide')}
          icon={<FindInPageOutlinedIcon />}
          onClick={openQuickGuide}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <CardHomeTeacherLink
          title={t('btn_notes_and_feedback')}
          subtitle={t('subtitle_notes_and_feedback')}
          path="/myevents/list"
          icon={<TextsmsOutlinedIcon />}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <CardHomeAnalyticsStudent
          title={t('btn_student_performance')}
          subtitle={t('subtitle_student_performance')}
          icon={<LeaderboardOutlinedIcon />}
        />
      </Grid>
      {permissions?.includes('read_event') && (
        <Grid item xs={12} md={6}>
          <CardStudentLink
            title={t('btn_schedule_events')}
            subtitle={t('subtitle_schedule_events')}
            path="/events/schedule"
            icon={<TodayOutlinedIcon />}
          />
        </Grid>
      )}
    </Grid>
  )
}
